/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoutesAPIOrderResponse } from '../models/RoutesAPIOrderResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OrderbookDataExperimentalService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get listings / offers for all NFTs in a collection
     * Returns order data (from supported marketplaces) for all assets in a specified collection
     * @returns RoutesAPIOrderResponse OK
     * @throws ApiError
     */
    public getOrderbookData({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
        limit,
        marketplace = '',
        offset,
        orderType = '',
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        limit?: number | null,
        /** The marketplace can be filtered by selecting one of the following options: opensea, looksrare, or x2y2. If no selection is made, the API will return a combined result **/
        marketplace?: '' | 'looksrare' | 'x2y2' | 'opensea',
        offset?: number | null,
        /** The order type for the optional parameter can either be BID or ASK. If left blank, the API will provide a consolidated result **/
        orderType?: '' | 'bid' | 'ask',
    }): CancelablePromise<RoutesAPIOrderResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/experimental/{network}/{address}/orderbook',
            path: {
                'address': address,
                'network': network,
            },
            query: {
                'limit': limit,
                'marketplace': marketplace,
                'offset': offset,
                'orderType': orderType,
            },
        });
    }

    /**
     * Get listings / offers for a particular NFT
     * Returns order data (from supported marketplaces) for a specified asset
     * @returns RoutesAPIOrderResponse OK
     * @throws ApiError
     */
    public getOrderbookDataByTokenId({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
        tokenId = '1',
        includeCollectionOffers = true,
        limit,
        marketplace = '',
        offset,
        orderType = '',
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        /** Token ID **/
        tokenId?: string,
        /** If false, the response will exclude collection offers **/
        includeCollectionOffers?: boolean,
        limit?: number | null,
        /** The marketplace can be filtered by selecting one of the following options: opensea, looksrare, or x2y2. If no selection is made, the API will return a combined result **/
        marketplace?: '' | 'looksrare' | 'x2y2' | 'opensea',
        offset?: number | null,
        /** The order type for the optional parameter can either be BID or ASK. If left blank, the API will provide a consolidated result. **/
        orderType?: '' | 'bid' | 'ask',
    }): CancelablePromise<RoutesAPIOrderResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/experimental/{network}/{address}/{tokenID}/orderbook',
            path: {
                'address': address,
                'network': network,
                'tokenID': tokenId,
            },
            query: {
                'includeCollectionOffers': includeCollectionOffers,
                'limit': limit,
                'marketplace': marketplace,
                'offset': offset,
                'orderType': orderType,
            },
        });
    }

}